
export const ACCESS_TYPE_OPTIONS = [
  ["code", "Xtream Codes"],
  ["m3u", "M3U"],
  ["code_m3u", "Code + M3U"],
  ["mac", "MAC / Device ID"],
  ["activation_code", "Code d’activation"],
  ["portal_mag", "Portal / MAG"],
  ["other", "Autre"],
];

export const needsCodeAccess = (accessType) => ["code", "code_m3u"].includes(accessType || "code");

export const needsM3uAccess = (accessType) => ["m3u", "code_m3u"].includes(accessType || "code");

export const needsMacAccess = (accessType) => ["mac", "portal_mag"].includes(accessType || "");

export const accessTypeLabel = (accessType) => ACCESS_TYPE_OPTIONS.find(([value]) => value === (accessType || "code"))?.[1] || "Xtream Codes";

export function SubscriptionAccessFields({ form, setForm, prefix }) {
  const accessType = form.access_type || "code";
  const showCode = needsCodeAccess(accessType);
  const showM3u = needsM3uAccess(accessType);
  const showMac = needsMacAccess(accessType);
  const changeAccessType = (value) => {
    setForm({
      ...form,
      access_type: value,
      ...(needsCodeAccess(value) ? {} : { username: "", password: "", portal_url: "" }),
      ...(needsM3uAccess(value) ? {} : { m3u_url: "" }),
      ...(needsMacAccess(value) ? {} : { device: "", mac_address: "" }),
    });
  };
  return (
    <div className="grid gap-3" data-testid={`${prefix}-access-fields`}>
      <label className="text-xs uppercase tracking-wider text-slate-400" data-testid={`${prefix}-access-type-label`}>Type d’accès</label>
      <select className="field" value={accessType} onChange={(event) => changeAccessType(event.target.value)} data-testid={`${prefix}-access-type-select`} required>
        {ACCESS_TYPE_OPTIONS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
      </select>
      {showCode && <div className="form-grid" data-testid={`${prefix}-code-fields`}>
        <input className="field" placeholder="Username" value={form.username || ""} onChange={(event) => setForm({ ...form, username: event.target.value })} data-testid={`${prefix}-username-input`} required />
        <input className="field" type="text" placeholder="Password" value={form.password || ""} onChange={(event) => setForm({ ...form, password: event.target.value })} data-testid={`${prefix}-password-input`} required />
      </div>}
      {showCode && <input className="field" placeholder="Portal URL" value={form.portal_url || ""} onChange={(event) => setForm({ ...form, portal_url: event.target.value })} data-testid={`${prefix}-portal-input`} required />}
      {showM3u && <input className="field" placeholder="M3U URL" value={form.m3u_url || ""} onChange={(event) => setForm({ ...form, m3u_url: event.target.value })} data-testid={`${prefix}-m3u-input`} required />}
      {showCode && <input className="field" placeholder="Backup portal URL" value={form.backup_portal_url || ""} onChange={(event) => setForm({ ...form, backup_portal_url: event.target.value })} data-testid={`${prefix}-backup-input`} />}
      {(showCode || showMac) && <input className="field" placeholder="Application recommandée" value={form.recommended_application || ""} onChange={(event) => setForm({ ...form, recommended_application: event.target.value })} data-testid={`${prefix}-app-input`} />}
      {showMac && <div className="form-grid" data-testid={`${prefix}-device-fields`}>
        <input className="field" placeholder="Appareil" value={form.device || ""} onChange={(event) => setForm({ ...form, device: event.target.value })} data-testid={`${prefix}-device-input`} />
        <input className="field" placeholder="MAC address" value={form.mac_address || ""} onChange={(event) => setForm({ ...form, mac_address: event.target.value })} data-testid={`${prefix}-mac-input`} />
      </div>}
    </div>
  );
}